import * as React from 'react';
import { Masonry } from '@leagueplatform/masonry';
import { CHAT_HISTORY_ROOT_NODE_IDS } from '../constants/masonry.constants';

export function ChatHistoryPage() {
  return (
    <Masonry
      rootNodeId={CHAT_HISTORY_ROOT_NODE_IDS.chatHistoryPageRootNodeId}
    />
  );
}
